/**
 * Step 6 - Select all or unselect all items currently on the page
 * @param {*} currentPage
 * @param {*} itemsPerPage
 * @param {*} lots
 * @param {*} selectedLots
 * @returns Set
 */
export const handleSelectAllByIdStep6 = (currentPage, itemsPerPage, lots, selectedLots) => {
  const updatedLots = new Set(selectedLots);

  /**
   * For instance: current page is 1 (the second page), and 50 lots per
   * page, we want to select lots 50-99 If the current page is 0,
   * with 50 lots per page, select lots 0-49
   */
  const minIndex = currentPage * itemsPerPage;

  // Check if this is the last page and truncate the number of items per page if true
  let checkedItemsPerPage = itemsPerPage;
  if (minIndex + itemsPerPage > lots.length) {
    checkedItemsPerPage = lots.length % itemsPerPage;
  }

  // For each item in the list get its id and add to the list
  const arrayOfValues = [];
  for (let i = 0; i < checkedItemsPerPage; i += 1) {
    const index = currentPage * itemsPerPage + i;
    arrayOfValues.push({
      lot: (['lotID'] in lots[index] ? lots[index].lotID : ''),
      deleted: lots[index].deleted || false,
    });
  }

  const numDeletedPerPage = arrayOfValues.reduce((total, value) => (
    value.deleted ? ++total : total), 0);
  const selectedItems = arrayOfValues.filter(value => selectedLots.has(value.lot)).length;

  /**
   * If every item in this array of values is currently in selected lots - the user wants to
   * "unselect" them all
   */
  const allItemsSelected = selectedItems === (checkedItemsPerPage - numDeletedPerPage);

  if (allItemsSelected) {
    // Unselect all items currently on the page
    arrayOfValues.forEach(value => updatedLots.delete(value.lot));
  } else {
    // Select all items currently on the page
    arrayOfValues.forEach(value => !value.deleted && updatedLots.add(value.lot));
  }

  return updatedLots;
};

